import {Injectable} from "@angular/core";
import {DialogService} from "~/app/core/dialog.service";
import {ToastService} from "~/app/core/toast.service";
import {LocationService} from "~/app/core/location.service";
import {CameraService} from "~/app/core/camera.service";
import {ModalService} from "~/app/core/modal.service";
import {NavigationService} from "~/app/core/navigation.service";
import {RPCService} from "~/app/core/rpc.service";
import {Platform} from "@ionic/angular";
import {MapService} from "~/app/core/maps.service";
import {InstallService} from "~/app/core/install.service";
import {StorageService} from "~/app/core/storage.service";
import {NotificationService} from "~/app/core/notification.service";
import {SettingsService} from "~/app/core/settings.service";
import {ApiService} from "~/app/core/api.service";
import {GamificationService} from "~/app/core/gamification.service";
import {InteractionService} from "~/app/core/interaction.service";
import {NetworkService} from "~/app/core/network.service";
import {ShareService} from "~/app/core/share.service";
import {SuspendService} from "~/app/core/suspend.service";

@Injectable()
export class CoreService {
    platform: Platform;
    camera: CameraService;
    dialogs: DialogService;
    location: LocationService;
    notify: NotificationService;
    maps: MapService;
    modal: ModalService;
    install: InstallService;
    nav: NavigationService;
    storage: StorageService;
    rpc: RPCService;
    toast: ToastService;
    settings: SettingsService;
    api: ApiService;
    gamification: GamificationService;
    interaction: InteractionService;
    net: NetworkService;
    share: ShareService;
    suspend: SuspendService;

    constructor(
      platform: Platform,
      camera: CameraService,
      dialog: DialogService,
      location: LocationService,
      notify: NotificationService,
      maps: MapService,
      install: InstallService,
      modal: ModalService,
      nav: NavigationService,
      storage: StorageService,
      rpc: RPCService,
      toast: ToastService,
      settings: SettingsService,
      api: ApiService,
      gamification: GamificationService,
      interaction: InteractionService,
      network: NetworkService,
      share: ShareService,
      suspend: SuspendService,
    ) {
        this.platform = platform;
        this.camera = camera;
        this.dialogs = dialog;
        this.location = location;
        this.notify = notify;
        this.maps = maps;
        this.install = install;
        this.modal = modal;
        this.nav = nav;
        this.storage = storage;
        this.rpc = rpc;
        this.toast = toast;
        this.settings = settings;
        this.api = api;
        this.gamification = gamification;
        this.install = install;
        this.net = network;
        this.share = share;
        this.suspend = suspend;
    }
}
